import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

import { WorkshopDto } from "../../types/workshopTypes";
import EventChip from "../events/EventChip";
import { Link } from "react-router-dom";

interface WorkshopsOverviewCardProps {
  workshop: WorkshopDto;
}

/**
 * Component to display a card of a workshop
 * @param workshop - the workshop to display
 * @returns the workshop in a card
 */
const WorkshopsOverviewCard = ({ workshop }: WorkshopsOverviewCardProps) => {
  return (
    <Card sx={{ minHeight: 100 }} key={workshop.workshopId}>
      <Link to={`/workshops/${workshop.workshopId}`} style={{ textDecoration: "none", color: "inherit" }}>
        <CardContent>
          <EventChip type={workshop.type} size="small" sx={{ ml: -0.5 }} />
          <Typography variant="body1" fontWeight={"bold"}>
            {workshop.workshopName}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {workshop.description}
          </Typography>
        </CardContent>
      </Link>
    </Card>
  );
};

export default WorkshopsOverviewCard;
